var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1321.7 1233.8",
    style: {
      enableBackground: "new 0 0 1321.7 1233.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000169553746681478439970000017319473529848172455_);fill:#FC7685;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1321.7,
    height: 1233.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151534133076505312390000010036280503415134130_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000151534133076505312390000010036280503415134130_)",
      fill: "#FC7685"
    },
    d: "M812.9,889.7 c4,48.6,11.2,87,21.4,115c10.3,28,24,47.2,41.2,57.5c17.2,10.3,38.9,15.4,65.2,15.4c27.5,0,49.8-6.6,66.9-19.7 c17.2-13.1,30.6-35.4,40.3-66.9c9.7-31.5,16.6-73.5,20.6-126.1c4-52.6,6-117.8,6-195.6V537.1c0-76.6-2-139.3-6-187.9 c-4-48.6-11.2-86.9-21.4-115c-10.3-28-24-47.2-41.2-57.5c-17.2-10.3-38.9-15.4-65.2-15.4c-27.5,0-49.8,6.6-66.9,19.7 c-17.2,13.2-30.6,35.5-40.3,66.9c-9.7,31.5-16.6,73.5-20.6,126.1c-4,52.6-6,117.8-6,195.6v132.1 C806.9,778.5,808.9,841.1,812.9,889.7 M568.4,405c5.7-77.8,21.2-146.7,46.3-206.8c25.1-60.1,63.2-108.1,114.1-144.1 C779.7,18,850.3,0,940.7,0c74.3,0,135.8,10.6,184.5,31.7c48.6,21.2,87.5,55.2,116.7,102.1c29.2,46.9,49.8,107.8,61.8,182.8 c12,74.9,18,166.2,18,273.7c0,84.7-2.9,165.9-8.6,243.7c-5.7,77.8-21.2,146.7-46.3,206.8c-25.2,60.1-63.2,107.2-114.1,141.6 c-50.9,34.3-121.6,51.5-211.9,51.5c-73.2,0-134.4-9.7-183.6-29.2c-49.2-19.4-88.4-52.6-117.5-99.5 c-29.2-46.9-49.8-107.8-61.8-182.8c-12-74.9-18-166.2-18-273.7C559.8,564,562.6,482.8,568.4,405 M242,356.9H0V195.6h22.3 c82.4,0,147.3-15.4,194.8-46.3c47.5-30.9,77.5-80.7,90.1-149.3H489v1214.9H242V356.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo10);
export default __webpack_public_path__ + "static/media/no-10.d7adefd84a79426e7ab2b521de15a19b.svg";
export { ForwardRef as ReactComponent };